import React, { useState, useEffect, FC } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

interface LoadingPopupProps {
  open: boolean;
  progress?: number;
  type ?: 'starting' | 'reading' | 'completed';
  onClose: () => void;
}

const LoadingPopup: FC<LoadingPopupProps> = ({ open, progress, type, onClose}) => {
  const isPBM = (localStorage.getItem('connectedDeviceType') === 'PBM');
  type = (isPBM || (progress ?? -1) > 0) ? 'reading' : 'starting';
  const isReading = type === 'reading';
  return (
    <Dialog 
      onClose={(event, reason) => {
				if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') 
					onClose();
			}}
      open={open} 
      maxWidth="xs" 
      PaperProps={{ style: { width: '339px', height: '150px' } }} 
      id="reading"
    >
      <DialogContent 
        style={{
        padding: '15px 20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        }}
      >

    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center'}}>
      <img
        src="assets/logos/relay.svg"
        alt="icon"
        style={{ width: '100px', height: '60px' }}
      />
    </div>
    <div style={{ textAlign: 'center' }}>
          {(isReading || isPBM) && (
            <LinearProgress
              variant="determinate"
              value={progress ?? 0}
              style={{ width: '100%', marginBottom: '8px' }}
              sx={{ '& .MuiLinearProgress-bar': { transition: 'none' } }}
            />
          )}

        <Typography
          className="!font-jost"
          align="center"
          variant="subtitle1"
        >
          {type.includes('reading') && 'Reading...'}
          {type.includes('completed') && 'Completed'}
          {(!type || type.includes('starting')) && 'Preparing...'}
        </Typography>
      </div>
      </DialogContent>
    </Dialog>
  );
}

export default LoadingPopup;
